export default __webpack_public_path__ + "static/media/05_HeYe.a1adc7ae.png";